import FeatureLayer from "./FeatureLayer";

export default FeatureLayer;
